


























































































import { Vue, Component, Prop } from 'vue-property-decorator'

import tournamentStore from '@/modules/tournament/tournament.store'
import userStore from '@/modules/auth/auth.store'
import { getModule } from 'vuex-module-decorators'
import { MemberEntity, MemberGameAccountEntity } from '@/api/member'
import { TournamentEntity } from '@/api/tournament'
import { getGameTypes } from '@/utils/gameType'

@Component
export default class TeamDetailReview extends Vue {
  @Prop({ type: String, required: true }) readonly teamName!: string
  @Prop({ type: String, default: '' }) readonly group!: string

  tournamentModule = getModule(tournamentStore, this.$store)

  userModule = getModule(userStore, this.$store)

  /* Computed Properties */
  get member(): MemberEntity | null {
    return this.userModule.member
  }

  get gameAccounts(): MemberGameAccountEntity[] | null {
    return this.member!.gameAccounts
  }

  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get isSoloTournament() {
    return this.tournament && this.tournament.capacityMaxPlayersPerTeam === 1
  }

  get tournamentGameAccount(): MemberGameAccountEntity | null {
    if (!this.gameAccounts || !this.tournament) return null
    const gameAccount = this.gameAccounts.find(
      account => account.game === this.tournament!.game
    )
    return gameAccount === undefined ? null : gameAccount
  }

  get game() {
    if (!this.tournament || !this.tournament.game) return ''
    const gameTypes = getGameTypes()
    const game = gameTypes.find(g => g.code === this.tournament!.game)
    if (!game) return this.tournament.game
    return game.name
  }
}
